import { render, staticRenderFns } from "./noDataPrompt.vue?vue&type=template&id=418010b3&scoped=true"
import script from "./noDataPrompt.vue?vue&type=script&lang=js"
export * from "./noDataPrompt.vue?vue&type=script&lang=js"
import style0 from "./noDataPrompt.vue?vue&type=style&index=0&id=418010b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418010b3",
  null
  
)

export default component.exports